import { useState, useEffect, useRef } from 'react';
import Calendar from '../calendar';
import { useSpacePublicZustandStore } from '@/helpers/spacepublicprovider';
import DateResume from '../calendar/resume';
import { useTranslation, lang } from '@/helpers/translate';

function CartridgeDates({ spaceCalendar, dataByCategory }) {
  const diary = useSpacePublicZustandStore((state) => state.lazyDiary);
  const { spaceRef } = useSpacePublicZustandStore.getState();
  const [open, setOpen] = useState(false);
  const datesSelected = useSpacePublicZustandStore((state) => state.datesSelected);
  const { t } = useTranslation();
  const calendarRef = useRef(null);

  useEffect(() => {
    if (Object.keys(datesSelected || {}).length > 0) {
      setOpen(false);
    }
  }, [datesSelected]);

  return (
    <>
      <div className="grid justify-between mb-2.5">
        <div className="flex flex-col items-center justify-between w-full col-span-12 px-3 py-2.5 transition rounded-lg cursor-pointer bg-purple-0 hover:bg-purple-0/80 text-purple-5/50" onClick={() => setOpen(!open)}>
          <div className="flex items-center justify-between w-full">
            <span className="text-base text-purple-5/80">{t('space:select_date')}</span>
            <div>
              <svg className="fill-current text-purple-5/50 transition-transform duration-300" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M5.25 1C5.25 0.723858 5.02614 0.5 4.75 0.5C4.47386 0.5 4.25 0.723858 4.25 1H5.25ZM4.25 3.25C4.25 3.52614 4.47386 3.75 4.75 3.75C5.02614 3.75 5.25 3.52614 5.25 3.25H4.25ZM15.75 1C15.75 0.723858 15.5261 0.5 15.25 0.5C14.9739 0.5 14.75 0.723858 14.75 1H15.75ZM14.75 3.25C14.75 3.52614 14.9739 3.75 15.25 3.75C15.5261 3.75 15.75 3.52614 15.75 3.25H14.75ZM0.5 16.75C0.5 17.0261 0.723858 17.25 1 17.25C1.27614 17.25 1.5 17.0261 1.5 16.75H0.5ZM1 5.5H1.5H1ZM18.5 16.75C18.5 17.0261 18.7239 17.25 19 17.25C19.2761 17.25 19.5 17.0261 19.5 16.75H18.5ZM1.5 16.75C1.5 16.4739 1.27614 16.25 1 16.25C0.723858 16.25 0.5 16.4739 0.5 16.75H1.5ZM19.5 16.75C19.5 16.4739 19.2761 16.25 19 16.25C18.7239 16.25 18.5 16.4739 18.5 16.75H19.5ZM0.5 16.75C0.5 17.0261 0.723858 17.25 1 17.25C1.27614 17.25 1.5 17.0261 1.5 16.75H0.5ZM1 9.25H0.5H1ZM3.25 7V7.5V7ZM18.5 16.75C18.5 17.0261 18.7239 17.25 19 17.25C19.2761 17.25 19.5 17.0261 19.5 16.75H18.5ZM4.25 1V3.25H5.25V1H4.25ZM14.75 1V3.25H15.75V1H14.75ZM1.5 16.75V5.5H0.5V16.75H1.5ZM1.5 5.5C1.5 4.5335 2.2835 3.75 3.25 3.75V2.75C1.73122 2.75 0.5 3.98122 0.5 5.5H1.5ZM3.25 3.75H16.75V2.75H3.25V3.75ZM16.75 3.75C17.7165 3.75 18.5 4.5335 18.5 5.5H19.5C19.5 3.98122 18.2688 2.75 16.75 2.75V3.75ZM18.5 5.5V16.75H19.5V5.5H18.5ZM0.5 16.75C0.5 17.4793 0.789731 18.1788 1.30546 18.6945L2.01256 17.9874C1.68437 17.6592 1.5 17.2141 1.5 16.75H0.5ZM1.30546 18.6945C1.82118 19.2103 2.52065 19.5 3.25 19.5V18.5C2.78587 18.5 2.34075 18.3156 2.01256 17.9874L1.30546 18.6945ZM3.25 19.5H16.75V18.5H3.25V19.5ZM16.75 19.5C18.2688 19.5 19.5 18.2688 19.5 16.75H18.5C18.5 17.7165 17.7165 18.5 16.75 18.5V19.5ZM1.5 16.75V9.25H0.5V16.75H1.5ZM1.5 9.25C1.5 8.2835 2.2835 7.5 3.25 7.5L3.25 6.5C1.73122 6.5 0.5 7.73122 0.5 9.25L1.5 9.25ZM3.25 7.5H16.75V6.5H3.25V7.5ZM16.75 7.5C17.7165 7.5 18.5 8.2835 18.5 9.25H19.5C19.5 7.73122 18.2688 6.5 16.75 6.5V7.5ZM18.5 9.25V16.75H19.5V9.25H18.5Z" />
              </svg>
            </div>
          </div>
          <div className="flex flex-col items-center justify-between w-full col-span-12 cursor-pointer gap-y-1 text-purple-5/50">
            <DateResume />
          </div>
        </div>
      </div>
      <div
        ref={calendarRef}
        className={`transition-all duration-300 ease-in-out ${open ? 'max-h-[1000px] opacity-100 mb-2.5' : 'max-h-0 opacity-0'}`}
      >
        <Calendar {...{ spaceCalendar, diary, dataByCategory }} />
      </div>
    </>
  );
}

export default CartridgeDates;
